import { NomadDB } from '~/db/NomadDB.js';
import type { ExerciseInfoSchema, ProgressionSchema } from '@/types/schema';

export const getExerciseInfosService = (db: NomadDB) => {
  const getByIdLibraryBookIdAndMemberID = async (
    contentId: string,
    libraryBookId: string,
    memberId: string
  ): Promise<ExerciseInfoSchema> => {
    const info = await db.exerciseInfos.get([
      contentId,
      libraryBookId,
      memberId,
    ]);
    return info;
  };

  const findByLibraryBookIdChapterIdAndMemberIDParams = async (
    params: string[][]
  ): Promise<ExerciseInfoSchema[]> => {
    const info = await db.exerciseInfos
      .where(['libraryBookId+chapterId+memberId'])
      .anyOf(params)
      .toArray();
    return info;
  };

  const findFinishedByLibraryBookIdAndMemberId = async (
    libraryBookId: string,
    memberId: string
  ): Promise<ExerciseInfoSchema[]> => {
    return await db.exerciseInfos
      .where(['libraryBookId+memberId+isFinished'])
      .anyOf([[libraryBookId, memberId, 1]])
      .toArray();
  };

  const findByMemberIdAndLibraryBookId = async (
    libraryBookId: string,
    memberId: string
  ) => {
    return await db.exerciseInfos
      .where(['libraryBookId+memberId'])
      .anyOf([[libraryBookId, memberId]])
      .toArray();
  };

  const update = async (key: any, data: any) => {
    // key [contentId, libraryBookId, memberId]
    return await db.exerciseInfos.update(key, data);
  };

  const bulkPut = async (data: any) => {
    return await db.exerciseInfos.bulkPut(data);
  };

  const clear = async (): Promise<any> => {
    return await db.exerciseInfos.clear();
  };

  const statsExerciseInfosSave = async (
    libraryBookId: string,
    progression: ProgressionSchema
  ): Promise<number> => {
    try {
      const { contentId, member: memberId, data } = progression;
      const dataExercise = data as ExerciseDetailsProgression;
      const score = dataExercise.points / dataExercise.maxPoints;

      const info = await getByIdLibraryBookIdAndMemberID(
        progression.contentId,
        libraryBookId,
        progression.member
      );

      if (info) {
        const newInfo = {
          ...info,
          score,
          isFinished: dataExercise.status === 'done' ? 1 : 0,
          points: dataExercise.points,
          maxPoints: dataExercise.maxPoints,
        };
        return await update([contentId, libraryBookId, memberId], newInfo);
      }
    } catch (e) {
      console.error('useStatsQuizInfosSave ::', e);
    }
  };

  // Add function retrieveLibraryBookExerciseCoachingStats
  // // averageGrade: number; // score des exercices faits du lb ( 0 à 100 )
  // // globalScore: number; // prgression nombre d'exercises faits / total ( 0 à 100 )

  return {
    getByIdLibraryBookIdAndMemberID,
    findFinishedByLibraryBookIdAndMemberId,
    update,
    bulkPut,
    clear,
    statsExerciseInfosSave,
    findByLibraryBookIdChapterIdAndMemberIDParams,
    findByMemberIdAndLibraryBookId,
  };
};
